"use strict";

export const DEFAULT_TOUCH_SLOP = 15;
export const MINIMAL_RECOGNIZABLE_MAGNITUDE = 0.1;
//# sourceMappingURL=constants.js.map